/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
// global elements
import Structure from 'components/shared/structure/structure_container';
// unique elements
// import Frame from 'components/frames/frame_container';
import Title from 'components/shared/title/title';
import BodyCopy from 'components/shared/bodycopy/bodycopy';
import CTAs from 'components/shared/ctas/ctas';
import Button from 'components/shared/button/button';
// import Close from 'components/shared/close/close';
// utils
import { url } from 'utils/urls';
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/screens/answererror/answererror_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ ANSWER ERROR SCREEN: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class AnswerErrorScreen extends Component {
    handleContinue = (e) => {
        this.props.displayScreen({ name: 'answerError', type: 'full', visible: false, content: null });
        this.props.skipQuestion();
        refreshAds();
    };
    createMarkup() {
        return (
            <div className={`answererror uniquescreen`}>
                <Title>{`Something went wrong `}</Title>
                <BodyCopy>
                    <p>Sorry, we couldn’t load the answer for your last question.</p>
                </BodyCopy>
                <CTAs type={`inline`}>
                    <Button klass={`blue`} onClick={this.handleContinue}>{`Continue`}</Button>
                </CTAs>
            </div>
        );
    }
    render() {
        return(
            <div className={`${sheet.classes.uniquecontent} uniquecontent inview-${this.props.inView}`}>
                <Structure contentId={this.props.contentId} markup={this.createMarkup()} />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AnswerErrorScreen;
